import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { cloneDeep } from 'lodash';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { Message, ConfirmationService, ConfirmEventType, MenuItem } from 'primeng/api';

@Component({
  selector: 'app-assessment-topics',
  templateUrl: './assessment-topics.component.html',
  styleUrls: ['./assessment-topics.component.scss','../../../../mystery-shopper/mystery-shopper.component.scss']
})
export class AssessmentTopicsComponent {
  header = this.translate('Add Topic');
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-refresh',
      link: '/assessment',
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Add Topic'), link: '/assessment/topics' },
  ];
  queryParams: any = {};
  stats: stat[] = [];
  messages: Message[] = [];
  topics: any[] = [];
  isEdit: boolean = false;
  editTopicId: string = "";
  topicName: string = ""

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
        this.clearForm();
        Promise.all([this.fetchTopics()]);
    })
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  private async fetchTopics(): Promise<void> {
    let res = await this.dataService.getData(`question-bank/get-topics/1/1000/Topic`);
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.topics = res.data;
  }

  isFormValid(): boolean {
    return (
      this.topicName !== ''
    );
  }

  clearForm() {
    this.topicName = "";
  }

  async createTopic() {
    
    if (this.isFormValid()) {
        try {

          let data : any = {
            name: this.topicName,
            type:'Topic'
          }
          let res;
          if (this.isEdit)
          {
            res = await this.dataService.postData('question-bank/' + this.editTopicId, data,'PUT',false);
            this.isEdit = false;
          } else{
            res = await this.dataService.postData('question-bank', data);
          }
          if (res.error) return
          this.ngOnInit();
        } catch (error) {
          console.log(error)
        }
    }
    else{
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate("Please Provide all Valid Data") },
      ];
      return;
    }
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
  }

  loadTopic(topic: any) {
    this.isEdit = true;
    this.editTopicId = topic._id;
    this.topicName   = topic.name; 
  }

  deleteTopic(topicId: string, $event: any){
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let res = await this.dataService.deleteData(`question-bank/${topicId}`);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });

  }

  cancelEdit() {
    this.clearForm();
    this.isEdit = false;
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

}
